import { render, staticRenderFns } from "./AfaSchedaValutazioneMedicoSportivaViewComponent.vue?vue&type=template&id=7dc38e3c"
import script from "./AfaSchedaValutazioneMedicoSportivaViewComponent.vue?vue&type=script&lang=js"
export * from "./AfaSchedaValutazioneMedicoSportivaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports